import darkLogo from "../../assets/logo.png";
import lightLogo from "../../assets/logo-white.png";

interface ILogoProps {
  variant?: "light" | "dark";
  width?: number | string;
  height?: number | string;
}

export const Logo: React.FC<ILogoProps> = ({
  variant = "dark",
  width = "auto",
  height = "auto",
}) => {
  return (
    <img
      src={variant === "dark" ? darkLogo : lightLogo}
      alt="SellerScout logo"
      width={width}
      height={height}
    />
  );
};

export default Logo;
